import { createContext } from 'react';

export const EventSettingsContext = createContext(undefined);
export const EventSettingsProvider = EventSettingsContext.Provider;
